export function generateHeaders() {
    return {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionStorage.getItem('_at')}`,
    }
}
